/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import DestinationServicesCrudTable from './crudTables/destinationServicesCrud.component';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import InternationalSchoolingCrudTable from './crudTables/internationalSchoolingCrud.component';
import LanguageTrainingCrudTable from './crudTables/languageTrainingCrud.component';
import React from 'react';
import { ZERO_GUID } from '../visaTab.component';

export const GlobalDestinationServices = ({ details, id: authId, isReadOnly, enumerations, vendors, vendorContacts, allVendors }) => {
  const { isLoading } = useSelector(state => ({
    isLoading: state.authorizations.isLoading
  }));

  const familyMembers = Array.isArray(details?.familyMembers) ? details.familyMembers : [];

  const destinationData = Array.isArray(details?.global?.globalDestinationInfo) ? details.global.globalDestinationInfo : [];

  const langData = Array.isArray(details?.global?.globalLanguageTrainingInfo) ? details.global.globalLanguageTrainingInfo : [];

  const intlData = Array.isArray(details?.global?.globalIntlSchoolingInfo) ? details.global.globalIntlSchoolingInfo : [];

  const globalId = details?.global?.globalInfo?.globalAssignmentId;

  const countries =
    Array.isArray(enumerations?.countries) && enumerations.countries.length > 0
      ? enumerations.countries.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  return (
    <>
      {isLoading ? (
        <FullscreenSpinner />
      ) : (
        <Grid container spacing={1} sx={{ padding: '20px' }}>
          <Grid item xs={12} md={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <DestinationServicesCrudTable
              globalId={globalId}
              authId={authId}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              destinationData={destinationData}
              vendors={vendors}
              vendorContacts={vendorContacts}
              countries={countries}
              allVendors={allVendors}
              familyMembers={familyMembers}
            />
            <LanguageTrainingCrudTable
              globalId={globalId}
              authId={authId}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              languageData={langData}
              vendors={vendors}
              vendorContacts={vendorContacts}
              familyMembers={familyMembers}
              countries={countries}
              allVendors={allVendors}
            />
            <InternationalSchoolingCrudTable
              globalId={globalId}
              authId={authId}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              schoolingData={intlData}
              vendors={vendors}
              vendorContacts={vendorContacts}
              familyMembers={familyMembers}
              countries={countries}
              allVendors={allVendors}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default GlobalDestinationServices;
